// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1xR56","footer":"ModalCreateQualiphyProcedure_footer__8u0Wz","additionData":"ModalCreateQualiphyProcedure_additionData__16S_5"};